const nzd = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' });
const dateFmt = new Intl.DateTimeFormat('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' });

export const money = (n: number | string | null | undefined) =>
  n === null || n === undefined || n === '' ? '' : nzd.format(Number(n));

export const date = (d: string | null | undefined) => (d ? dateFmt.format(new Date(d)) : '');

export const percent = (n: number | null | undefined, dp = 1) =>
  n === null || n === undefined || Number.isNaN(n) ? '' : `${n.toFixed(dp)}%`;

/** Parse a number from an input, allowing blanks. */
export const num = (s: string): number | undefined => {
  const v = s.trim() === '' ? NaN : Number(s.replace(/[$,%\s]/g, ''));
  return Number.isFinite(v) ? v : undefined;
};

/** Escape % and _ for a Postgres ilike pattern. */
export const likeEscape = (s: string) => s.replace(/[%_\\]/g, (c) => `\\${c}`);

export const isOverdue = (d: string | null | undefined) =>
  !!d && new Date(d).getTime() < new Date(new Date().toDateString()).getTime();
